import * as Sentry from '@sentry/react'

export type OauthState = {
  redirectTo?: string
  token?: string
}

// Safely parses OAuth state from URL parameter
export const parseState = (state?: string | null): OauthState | null => {
  if (!state) {
    return null
  }

  try {
    return JSON.parse(decodeURIComponent(state)) as OauthState
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        state
      }
    })

    return null
  }
}
